export default class Doador {
    
    constructor(model = null){
        this.id = 0;
        this.empresaId = 0;
        this.nome = '';
        this.tipo = 0;
        this.tipoStr = '';
        this.cpfCnpj = '';
        this.identidadeInscricaoEstadual = '';
        this.dataNascimentoFundacao = '';
        this.tipoContribuicao = 0;
        this.tipoContribuicaoStr = '';
        this.formaDoacao = 0;
        this.formaDoacaoStr = '';
        this.tipoIndicacao = false;
        // this.tipoIndicacaoStr = '';
        this.doacaoProposta = 0;
        this.tipoDoacao = 0;
        this.tipoDoacaoStr = '';
        this.enviarBoletoEmail = false;
        this.naoGerarRecebivel = false;
        this.indicadorId = null;
        this.relacionamentoId = 0;
        this.cep = '';
        this.logradouro = '';
        this.numero = '';
        this.bairro = '';
        this.cidade = '';
        this.estado = '';
        this.municipioId;
        this.bairro = '';
        this.pais = '';
        this.telefone = '';
        this.celular = '';
        this.email = '';
        this.situacao = 'A';
        this.situacaoStr = '';
        this.emissaoRecibo = 'S';
        this.emissaoReciboStr = '';
        this.emissaoNota = 'N';
        this.emissaoNotaStr = '';
        this.observacao = '';
        this.observacaoRecibo = '';
        this.projetoId = 0;
        this.planoContaId = 0;
        this.planoContaItemId = 0;
        this.aplicarJurosMulta = false;
        this.diaBom = 0;
        this.campo01 = '';
        this.campo02 = '';
        this.campo03 = '';
        this.campo04 = '';
        this.campo05 = '';
        this.regiaoId = null;
        this.pessoalId = null;
        //NFSe
        this.codigoServicoNota = "";
        this.codigoTributacaoMunicipioNota = "";
        this.codigoNbsNota = "";
        this.textoNota = "";
        
        this.contatos = [];

        if (!model)
            return;
        
        this.id = model.id ? model.id : 0;
        this.empresaId = model.empresaId;
        this.nome = model.nome;
        this.tipo = model.tipo;
        this.tipoStr = model.tipoStr;
        this.cpfCnpj = model.cpfCnpj;
        this.identidadeInscricaoEstadual = model.identidadeInscricaoEstadual;
        this.dataNascimentoFundacao = model.dataNascimentoFundacao ? new Date(model.dataNascimentoFundacao).yyyymmdd() : null;
        this.tipoContribuicao = model.tipoContribuicao;
        this.tipoContribuicaoStr = model.tipoContribuicaoStr;
        this.formaDoacao = model.formaDoacao;
        this.formaDoacaoStr = model.formaDoacaoStr;
        this.doacaoProposta = model.doacaoProposta;
        this.tipoIndicacao = model.tipoIndicacao;
        // this.tipoIndicacaoStr = model.tipoIndicacaoStr;
        this.tipoDoacao = model.tipoDoacao;
        this.tipoDoacaoStr = model.tipoDoacaoStr;
        this.enviarBoletoEmail = model.enviarBoletoEmail;
        this.naoGerarRecebivel = model.naoGerarRecebivel;
        this.indicadorId = model.indicadorId;
        this.indicador = model.indicador;
        this.enviarBoletoEmail = model.enviarBoletoEmail;
        this.relacionamentoId = model.relacionamentoId;
        this.cep = model.cep;
        this.logradouro = model.logradouro;
        this.numero = model.numero;
        this.bairro = model.bairro;
        this.cidade = model.cidade;
        this.estado = model.estado;
        this.municipioId = model.municipioId;
        this.bairro = model.bairro;
        this.pais = model.pais;
        this.telefone = model.telefone;
        this.celular = model.celular;
        this.email = model.email;
        this.situacao = model.situacao;
        this.situacaoStr = model.situacaoStr;
        this.emissaoRecibo = model.emissaoRecibo;
        this.emissaoReciboStr = model.emissaoReciboStr;
        this.emissaoNota = model.emissaoNota;
        this.emissaoNotaStr = model.emissaoNotaStr;
        this.observacao = model.observacao;
        this.observacaoRecibo = model.observacaoRecibo;
        this.projetoId = model.projetoId;
        this.projeto = model.projeto;
        this.planoContaId = model.planoContaId;
        this.planoContaItemId = model.planoContaItemId;
        this.aplicarJurosMulta = model.aplicarJurosMulta;
        this.diaBom = model.diaBom;
        this.campo01 = model.campo01;
        this.campo02 = model.campo02;
        this.campo03 = model.campo03;
        this.campo04 = model.campo04;
        this.campo05 = model.campo05;
        this.regiaoId = model.regiaoId;
        this.pessoalId = model.pessoalId;
        //NFSe
        this.codigoServicoNota = model.codigoServicoNota;
        this.codigoTributacaoMunicipioNota = model.codigoTributacaoMunicipioNota;
        this.codigoNbsNota = model.codigoNbsNota;
        this.textoNota = model.textoNota;

        this.contatos = model.contatos;
    }
}